export default __webpack_public_path__ + "static/media/error-x-icon.3fba7cd7.svg";